<template>
  <div class="login-page theme-light">
    <div class="loading" v-if="loading">Loading&hellip;</div>

    <div class="login-page__shell">
      <div class="login-page__brand">
        <img src="@/assets/img/logo-qupro.png" alt="Qupro" width="180">
      </div>

      <div class="form-card login-page__card">
        <ErrorApi/>
        <SuccessApi/>

        <div class="form-card__header">
          <h6 class="form-card__title">
            <i class="bi bi-box-arrow-in-right"></i>
            Ingresar a tu cuenta
          </h6>
        </div>

        <div class="form-card__body" @keyup.enter="login">
          <div class="form-card__field">
            <label class="form-card__label" for="login-email">E-mail</label>
            <input
              id="login-email"
              v-model="credentials.email"
              type="email"
              class="form-control"
              placeholder="tu@email.com"
              autocomplete="username"
              required
            >
          </div>

          <div class="form-card__field">
            <label class="form-card__label" for="login-password">Contraseña</label>
            <input
              id="login-password"
              v-model="credentials.password"
              type="password"
              class="form-control"
              placeholder="Contraseña"
              autocomplete="current-password"
              required
            >
          </div>

          <a href="/password/reset" class="login-page__link">¿Perdiste tu contraseña?</a>
        </div>

        <div class="form-card__footer login-page__footer">
          <button
            type="button"
            class="form-card__btn form-card__btn--primary login-page__submit"
            :disabled="loading"
            @click="login"
          >
            <i class="bi bi-arrow-right-circle"></i>
            Ingresar al sistema
          </button>
        </div>
      </div>

      <div class="login-page__signup">
        ¿Necesitás una cuenta? <a href="/register">Registrate acá</a>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorApi from '../global/Errores.vue';
import SuccessApi from '../global/Success.vue';
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    ErrorApi,
    SuccessApi,
  },
  data: function () {
    return {
      credentials: {
        email: null,
        password: null,
        device: 'qupro-app',
      },
    };
  },
  created() {
    this.$store.dispatch('authUser/getLoading');
  },
  computed: {
    ...mapState('authUser', {
      loading: state => state.loading,
    }),
  },
  methods: {
    ...mapActions('authUser', ['getLoading']),
    login() {
      this.getLoading();
      this.$http.post(process.env.VUE_APP_BASE_URL + '/login', this.credentials)
        .then((response) => {
          if (response.data.message == 'Success') {
            localStorage.setItem('token', response.data.token);
            this.$http.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
            window.location.href = '/ventas';
          }
        })
        .catch((error) => {
          this.getLoading();
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background-color: #4477bd;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.login-page__shell {
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-page__brand {
  margin-bottom: 24px;
}

.login-page__card {
  width: 100%;
  margin-bottom: 16px;
}

.login-page__link {
  display: inline-block;
  margin-top: 4px;
  font-size: 12px;
  color: #4a5568;
}

.login-page__link:hover {
  color: #1a2233;
  text-decoration: underline;
}

.login-page__footer {
  justify-content: stretch;
}

.login-page__submit {
  flex: 1;
  justify-content: center;
}

.login-page__signup {
  font-size: 13px;
  color: #fff;
  text-align: center;
}

.login-page__signup a {
  color: #fff;
  font-weight: 600;
  text-decoration: underline;
}

.login-page__signup a:hover {
  color: rgba(255, 255, 255, 0.85);
}
</style>
